define('apps/course-intro/views/regions/header',[
    'apps/course-intro/templates/regions/header',
    'components/tools-button/views/tools-button',
    'components/user-data/main'
], function (template, ToolsButtonView, userData) {
    "use strict";

    return Mn.LayoutView.extend({

        "regions": {
            "tools-button": ".tools"
        },

        "template": template,

        "onRender": function(){
            this.showChildView('tools-button', new ToolsButtonView({
                "model": this.model
            }));
        },

        "serializeData": function () {
            return _.extend(Mn.LayoutView.prototype.serializeData.call(this), {
                "showUser": true,
                "user": {
                    "displayName": userData.user.displayName
                }
            });
        }
    });
});

